import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useState, useEffect, useRef } from 'react';
import AdminTaskInfoCard from '../../ui/AdminTaskInfoCard';
import { useTranslation } from 'react-i18next';
import { TASK_TYPES_LABELS } from '../../api/admin/types';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { generateTaskRoutePath } from '../../helpers';
import Animate from '../../ui/Animate';
import { setIsModalOpen, setModalContent, setModalContentProps } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { useAppDispatch } from '../../store';
const AdminTasksList = ({ rallyId, tasks, onSorted, setIsSortingChanged, isChangesAllowed, }) => {
    const { i18n, t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [sortedTasks, setSortedTasks] = useState(tasks);
    const tasksRefs = useRef({});
    const animateRef = useRef(null);
    useEffect(() => {
        setSortedTasks(tasks);
    }, [tasks]);
    useEffect(() => {
        if (sortedTasks.length) {
            const result = sortedTasks.map((task, idx) => ({
                taskId: task.uid,
                sorting: idx + 1,
            }));
            onSorted(result);
        }
    }, [sortedTasks]);
    const showPublishedRallyModal = () => {
        dispatch(setIsModalOpen(true));
        dispatch(setModalContent(MODAL_CONTENT.cannotEditRally.key));
        dispatch(setModalContentProps({ rallyId }));
    };
    const moveTask = (index, direction) => {
        const targetIndex = direction === 'up' ? index - 1 : index + 1;
        if (targetIndex < 0 || targetIndex >= sortedTasks.length) {
            return;
        }
        // snapshot positions BEFORE DOM changes
        animateRef.current?.capture();
        // perform swap using functional update to avoid stale closure issues
        setSortedTasks((prev) => {
            const newTasks = [...prev];
            [newTasks[index], newTasks[targetIndex]] = [newTasks[targetIndex], newTasks[index]];
            return newTasks;
        });
        setIsSortingChanged(true);
    };
    const handleEditButtonClick = (rallyId, taskId) => {
        if (isChangesAllowed) {
            navigate(generateTaskRoutePath(APP_ROUTES.adminEditTask, rallyId, taskId));
        }
        else {
            showPublishedRallyModal();
        }
    };
    const onDeleteTask = (taskId) => {
        if (isChangesAllowed) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.confirmDeleteTask.key));
            dispatch(setModalContentProps({
                rallyId,
                taskId,
                sortedTasks,
            }));
        }
        else {
            showPublishedRallyModal();
        }
    };
    return (_jsx(_Fragment, { children: _jsx("div", { className: "admin-tasks-list", children: sortedTasks && (_jsx(Animate, { refs: tasksRefs, ref: animateRef, children: sortedTasks.map((task, index) => (_jsx(AdminTaskInfoCard, { ref: (el) => {
                        tasksRefs.current[task.uid] = el;
                    }, rallyId: rallyId, taskId: task.uid, title: task.title[i18n.language], internalTitle: task.internalTitle, taskType: t(`${TASK_TYPES_LABELS[task.answerType || 'info']}`), isComplete: !!task.status, onEdit: () => handleEditButtonClick(rallyId, task.uid), disableUp: index === 0, disableDown: index === sortedTasks.length - 1, moveTask: (direction) => moveTask(index, direction), onDeleteTask: onDeleteTask, isChangesAllowed: isChangesAllowed }, task.uid))) })) }) }));
};
export default AdminTasksList;
